import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { isArrayWithItems as u } from "../../../helpers/array-helper.js";
import "dayjs";
import r from "./slider.module.less.js";
import * as a from "@radix-ui/react-slider";
const x = ({
  name: s,
  labels: i,
  value: t,
  max: c = 100,
  min: d = 0,
  step: n = 1,
  ariaLabel: h,
  labelClassName: p,
  onValueChange: m
}) => /* @__PURE__ */ o("div", { children: [
  /* @__PURE__ */ o(
    a.Root,
    {
      className: r.sliderRoot,
      value: [t],
      name: s,
      max: c,
      min: d,
      step: n,
      onValueChange: (l) => m && m(l, s),
      children: [
        /* @__PURE__ */ e(a.Track, { className: r.sliderTrack, children: /* @__PURE__ */ e(a.Range, { className: r.sliderRange }) }),
        /* @__PURE__ */ e(a.Thumb, { className: r.sliderThumb, "aria-label": h })
      ]
    }
  ),
  u(i) && /* @__PURE__ */ e("ul", { className: r.labels, children: i.map((l) => /* @__PURE__ */ e("li", { className: [r.label, p].join(" "), children: l })) })
] });
export {
  x as Slider,
  x as default
};
